@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-section-detail {
    .section-summary {
      margin-top: 0.3em;
      margin-bottom: 1em;

      &.disable-gutters {
        margin-bottom: 0;
      }
    }
  }
}